import { render, staticRenderFns } from "./DashboardLiveStatisticsTwoMatches.vue?vue&type=template&id=d9be5446&scoped=true"
import script from "./DashboardLiveStatisticsTwoMatches.vue?vue&type=script&lang=js"
export * from "./DashboardLiveStatisticsTwoMatches.vue?vue&type=script&lang=js"
import style0 from "./DashboardLiveStatisticsTwoMatches.vue?vue&type=style&index=0&id=d9be5446&prod&lang=scss"
import style1 from "./DashboardLiveStatisticsTwoMatches.vue?vue&type=style&index=1&id=d9be5446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9be5446",
  null
  
)

export default component.exports